import styled from 'styled-components';

export const Tab = styled.div`
  display: flex;
  padding: 0 10px;
  box-sizing: border-box;
  border-bottom: 2px solid #f0f0f0;
`;

export const TabItem = styled.div`
  padding: 12px 14px;
  margin: 0 2px;
  font-size: 13px;
  font-weight: ${(props) => (props.active ? '700' : '500')};
  color: ${(props) => (props.active ? '#318300' : '#666')};
  border-bottom: 3px solid
    ${(props) => (props.active ? '#318300' : 'transparent')};
  margin-bottom: -2px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: #318300;
    border-bottom: 3px solid #a8d48a;
  }
`;
